import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const benefitsApi = {
  // Plans
  listPlans: (params) => api.get('/benefits/plans', { params }).then(unwrap),
  getPlan: (id) => api.get(`/benefits/plans/${id}`).then(unwrap),
  createPlan: (payload) => api.post('/benefits/plans', payload).then(unwrap),
  updatePlan: (id, patch) => api.patch(`/benefits/plans/${id}`, patch).then(unwrap),
  deletePlan: (id) => api.delete(`/benefits/plans/${id}`).then(unwrap),

  // Eligibility rules
  listEligibilityRules: (params) => api.get('/benefits/eligibility-rules', { params }).then(unwrap),
  createEligibilityRule: (payload) => api.post('/benefits/eligibility-rules', payload).then(unwrap),
  updateEligibilityRule: (id, patch) => api.patch(`/benefits/eligibility-rules/${id}`, patch).then(unwrap),
  deleteEligibilityRule: (id) => api.delete(`/benefits/eligibility-rules/${id}`).then(unwrap),
  eligiblePlans: (params) => api.get('/benefits/eligibility', { params }).then(unwrap),

  // Enrollment windows
  listWindows: (params) => api.get('/benefits/windows', { params }).then(unwrap),
  createWindow: (payload) => api.post('/benefits/windows', payload).then(unwrap),
  updateWindow: (id, patch) => api.patch(`/benefits/windows/${id}`, patch).then(unwrap),
  openWindow: (id) => api.put(`/benefits/windows/${id}/open`).then(unwrap),
  closeWindow: (id) => api.put(`/benefits/windows/${id}/close`).then(unwrap),

  // Elections
  listElections: (params) => api.get('/benefits/elections', { params }).then(unwrap),
  getElection: (id) => api.get(`/benefits/elections/${id}`).then(unwrap),
  createElection: (payload) => api.post('/benefits/elections', payload).then(unwrap),
  waiveElection: (id) => api.put(`/benefits/elections/${id}/waive`).then(unwrap),
  terminateElection: (id) => api.put(`/benefits/elections/${id}/terminate`).then(unwrap),

  // Dependents
  listDependents: (params) => api.get('/benefits/dependents', { params }).then(unwrap),
  createDependent: (payload) => api.post('/benefits/dependents', payload).then(unwrap),
  updateDependent: (id, patch) => api.patch(`/benefits/dependents/${id}`, patch).then(unwrap),
  deleteDependent: (id) => api.delete(`/benefits/dependents/${id}`).then(unwrap),

  // Life events
  listLifeEvents: (params) => api.get('/benefits/life-events', { params }).then(unwrap),
  createLifeEvent: (payload) => api.post('/benefits/life-events', payload).then(unwrap),
  approveLifeEvent: (id) => api.put(`/benefits/life-events/${id}/approve`).then(unwrap),
  rejectLifeEvent: (id) => api.put(`/benefits/life-events/${id}/reject`).then(unwrap),

  // Deduction feed
  getDeductions: (params) => api.get('/benefits/deductions', { params }).then(unwrap),
};
